import { render, staticRenderFns } from "./DataExport.vue?vue&type=template&id=63e8c114&"
import script from "./DataExport.vue?vue&type=script&lang=js&"
export * from "./DataExport.vue?vue&type=script&lang=js&"
import style0 from "./DataExport.vue?vue&type=style&index=0&id=63e8c114&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports